var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tabs',{staticClass:"mt-7 mb-4",attrs:{"fill":"","justified":"","pills":""}},_vm._l((_vm.Options),function(option){return _c('div',{key:option.id},[_c('b-tab',{attrs:{"title":option.text + (option.count!=null ? ' ('+option.count+ ')' : '')},on:{"click":function($event){return _vm.onChange(_vm.Options, option.value)}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }